import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type ApplicationInfo = {
    applicationId: string;
    name: string;
    description?: string;
    status: string;
    createdByEmail?: string;
    createdAt?: string;
    updatedAt?: string;
    isSharepointManaged?: boolean;
    enableExperimentalFeatures?: boolean;
    isAdmin?: boolean;
    sbu?: string;
};

export type AppStateType = {
    apiKey?: string;
    application?: ApplicationInfo;
    setApiKey: (apiKey: string) => void;
    setApplication: (application: ApplicationInfo) => void;
    setApiKeyAndApplication: (apiKey: string, application: ApplicationInfo) => void;
    clearAuth: () => void;
};

export const useAppState = create(
    persist<AppStateType>(
        set => ({
            apiKey: undefined,
            application: undefined,
            setApiKey: (apiKey: string) => set({ apiKey }),
            setApplication: (application: ApplicationInfo) => set({ application }),
            setApiKeyAndApplication: (apiKey: string, application: ApplicationInfo) => set({ apiKey, application }),
            clearAuth: () => set({ apiKey: undefined, application: undefined }),
        }),
        {
            name: "app-state",
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
export const getAppState = useAppState.getState;

export const sharepointTooltipMessage = "This project is associated with a Teams site, all documents must be managed through Sharepoint";

export const isSharepointManaged = () => {
    const state = getAppState();
    return state.application?.isSharepointManaged || false;
};

export const isSharepointManagedSet = () => {
    const state = getAppState();
    return state.application && (state.application.isSharepointManaged === false || state.application.isSharepointManaged === true);
};

export const isExperimentalFeaturesEnabled = () => {
    const state = getAppState();
    return state.application?.enableExperimentalFeatures || false;
};

export const isAdminUser = () => {
    const state = getAppState();
    return state.application?.isAdmin || false;
};
